var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowgo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6 7.49961H11.1C9.66786 7.49961 8.29434 8.06854 7.28165 9.08123C6.26895 10.0939 5.70002 11.4674 5.70002 12.8996C5.70002 14.3318 6.26895 15.7053 7.28165 16.718C8.29434 17.7307 9.66786 18.2996 11.1 18.2996H19.2V20.0996H11.1C9.19047 20.0996 7.35912 19.341 6.00886 17.9908C4.65859 16.6405 3.90002 14.8092 3.90002 12.8996C3.90002 10.9901 4.65859 9.1587 6.00886 7.80844C7.35912 6.45818 9.19047 5.69961 11.1 5.69961H15.6V2.09961L21 6.59961L15.6 11.0996V7.49961Z",
    fill: "#2D9F75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowgo);
export default __webpack_public_path__ + "static/media/arrowgo.fa1cd623ffe3ddc31ca04bb180824984.svg";
export { ForwardRef as ReactComponent };